import { foldazApi } from 'api'
import {
  UPDATE_MEMBERSHIP_REQUEST,
  UPDATE_MEMBERSHIP_SUCCESS,
  UPDATE_MEMBERSHIP_ERROR,
} from './types'

export const state = {
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [UPDATE_MEMBERSHIP_REQUEST] (state) {
    state.request.isLoading = true
  },
  [UPDATE_MEMBERSHIP_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [UPDATE_MEMBERSHIP_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  }
}

export const actions = {
  updateMembershipRole ({ commit }, { membership, role }) {
    commit(UPDATE_MEMBERSHIP_REQUEST)
    return foldazApi.put(`/memberships/${membership.id}`, {
      role: role
    })
      .then(() => commit(UPDATE_MEMBERSHIP_SUCCESS))
      .catch(error => commit(UPDATE_MEMBERSHIP_ERROR, error))
  },
  updateMembershipState ({ commit, dispatch }, { membership }) {
    commit(UPDATE_MEMBERSHIP_REQUEST)

    return foldazApi.put(`/memberships/${membership.id}`, {
      active: !membership.active
    })
      .then(() => commit(UPDATE_MEMBERSHIP_SUCCESS))
      .catch(error => commit(UPDATE_MEMBERSHIP_ERROR, error))
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/memberships/updateMembership.js